/**
 * Product description layouts — mobile carousel enhancement.
 *
 * Description HTML (generated by our content tool) is fixed, so this wraps
 * each feature / image / comparison grid at runtime in the theme's own
 * <slider-element> and appends a <slider-dots> pager. The theme components
 * handle scroll tracking, dot sync and keyboard nav; product-description-
 * layouts.css turns the grid into a scroll-snap row under 768px and fades
 * every tile except the .selected one.
 */
(function () {
  var GRID_SELECTOR = [
    ".feature-grid-2",
    ".feature-grid-3",
    ".feature-grid-4",
    ".feature-grid-3-5items",
    ".feature-grid-4-7items",
    ".feature-grid-2x2",
    ".comparison-grid-2",
    ".comparison-grid-3",
    ".comparison-grid-4",
  ]
    .map(function (cls) {
      return ".product-description-curated " + cls;
    })
    .join(",");

  var counter = 0;

  function enhance(grid) {
    if (grid.dataset.pdcCarousel) return;
    grid.dataset.pdcCarousel = "true";

    var count = grid.children.length;
    if (count < 2) return;

    var id = "pdc-slider-" + ++counter;

    var wrapper = document.createElement("div");
    wrapper.className = "pdc-carousel";

    var slider = document.createElement("slider-element");
    slider.className = "pdc-slider";
    slider.id = id;
    slider.setAttribute("selector", ":scope > * > *");
    slider.setAttribute("tabindex", "0");

    var dots = document.createElement("slider-dots");
    dots.className = "flickity-page-dots pdc-dots";
    dots.setAttribute("aria-controls", id);
    for (var i = 1; i <= count; i++) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "flickity-page-dot";
      dot.dataset.index = String(i);
      dot.setAttribute("aria-label", "Slide " + i);
      dot.setAttribute("aria-current", i === 1 ? "true" : "false");
      dots.appendChild(dot);
    }

    // slider-element only toggles .selected on page change; seed the first tile
    grid.children[0].classList.add("selected");

    grid.parentNode.insertBefore(wrapper, grid);
    wrapper.appendChild(slider);
    slider.appendChild(grid);
    wrapper.insertAdjacentElement("afterend", dots);
  }

  function initAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(enhance);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("page:loaded", initAll);
})();
